<template>
    <el-dialog
        :title="title"
        :visible.sync="visibles"
        :width="width"
        :height="height"
        :modal="modal"
        :top="top"
        :before-close="beforeClose"
        :left="left"
        @open="_open"
        @close="_close"
        :close-on-click-modal="closeOnClickModal"
        :append-to-body="appendToBody"
        v-bind="$attrs"
    >
        <slot class="content"></slot>
        <span slot="footer">
            <slot name="footer"></slot>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: 'Modal',
    props: {
        title: {
            type: String,
            default: () => $t('integration.tips')
        },
        width: {
            type: String
        },
        height: {
            type: String
        },
        modal: {
            type: Boolean,
            default: true
        },
        visible: {
            type: Boolean,
            default: false
        },
        top: {
            type: String,
            default: '8vh'
        },
        left: {
            type: String,
            default: '15vh'
        },
        // 关闭弹窗前的回调
        beforeClose: {
            type: Function
        },
        // 弹窗关闭回调
        close: {
            type: Function
        },
        // 打开的回调
        open: {
            type: Function
        },
        closeOnClickModal: {
            type: Boolean,
            default: true
        },
        appendToBody: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        visibles: {
            get: function() {
                return this.visible;
            },
            set: function(val) {
                this.$emit('update:visible', val); // 可以优化成model  或者minx
            }
        }
    },
    methods: {
        _close() {
            this.$emit('close');
        },
        _open() {
            this.$emit('open');
        }
    }
};
</script>
<style lang="scss" scoped>
.content {
    min-height: 200px;
    max-height: 750px;
    overflow: auto;
}

::v-deep .el-dialog {
    border: 5px solid $blue1;
    border-radius: 10px;
}

::v-deep .el-dialog__header {
    background-color: $blue1;
    padding: 5px 0;

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        padding-left: 20px;
        display: inline-block;
        width: calc(100% - 60px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-dialog__close:hover {
        color: $txtcolor8;
        background-color: $red;
    }
}

::v-deep .el-dialog__headerbtn {
    top: 5px;

    i {
        color: $txtcolor1;
        font-size: 18px;
    }
}

::v-deep .el-form-item__label {
    width: auto;
    white-space: nowrap;
    text-align: right;
}

::v-deep .el-form-item__content {
    margin-left: 0;
}

::v-deep.el-dialog__body {
    padding: 15px;
}

::v-deep .el-dialog__footer {
    text-align: center;
    padding: 20px 0px 20px 0px;
    border-top: 1px solid #ebeef5;
    // border-top: 1px solid #f2f2f2;
}

::v-deep .el-button {
    margin-right: 15px;
}
</style>
